const API_VERSION = 'v1';

export const endpoints = {
  ceppemAi: {
    openConnection: `${API_VERSION}/open-connection`,
    chat: `${API_VERSION}/chat`,
    streamChat: `${API_VERSION}/chat/stream`,
    session: `${API_VERSION}/chat/sessions`,
    conversations: `${API_VERSION}/conversations`,
    userStream: `${API_VERSION}/stream`,
    quickActions: `${API_VERSION}/quick-actions`,
    files: `${API_VERSION}/chat/files`,
    chatAttachments: `${API_VERSION}/chat/attachments`,
    topics: `${API_VERSION}/topics`,
    connectors: `${API_VERSION}/connectors`,
    memories: `${API_VERSION}/memories`,
    preferences: `${API_VERSION}/preferences`,
    knowledge: `${API_VERSION}/knowledge`,
    automations: `${API_VERSION}/automations`
  },
  core: {
    fields: `${API_VERSION}/core/fields`,
    forms: `${API_VERSION}/core/forms`,
    configs: {
      plm: `${API_VERSION}/core/configs/plm`
    }
  },
  customer: {
    analiseMercado: {
      receitaAnualPretendida: `${API_VERSION}/customer/analises-de-mercado`,
      receitaAnualPretendidaRevisao: `${API_VERSION}/customer/analises-de-mercado/revisoes`,
      receitaAnualPretendidaPortfolio: `${API_VERSION}/customer/analises-de-mercado/portfolios`,
      oportunidades: `${API_VERSION}/customer/analises-de-mercado/oportunidades`,
      dashboard: `${API_VERSION}/customer/analises-de-mercado/dashboard`
    },
    cliente: `${API_VERSION}/customer/clientes`,
    clientesCarteiras: `${API_VERSION}/customer/clientes-carteiras`
  },
  environment: {
    gruposRentabilidade: `${API_VERSION}/environment/grupos-rentabilidade`,
    portfolio: `${API_VERSION}/environment/portfolios`,
    condicoesPagamentos: `${API_VERSION}/environment/condicoes-pagamentos`,
    concorrentes: `${API_VERSION}/environment/concorrentes`,
    // Endpoint legado sem prefixo de versão/dominio — mantido para compat com a API atual.
    feriado: 'feriado'
  },
  preparation: {
    tabelasPrecos: `${API_VERSION}/preparation/tabelas-precos`,
    importacoesPlanilhaPrecos: `${API_VERSION}/preparation/tabelas-precos/spreadsheets/planilha-precos/imports`,
    exportacoesPlanilhaPrecos: `${API_VERSION}/preparation/tabelas-precos/spreadsheets/planilha-precos/exports`,
    analisesMarketShare: `${API_VERSION}/preparation/analises-market-share`,
    analisesMarketShareLote: `${API_VERSION}/preparation/analises-market-share-lote`
  },
  product: {
    classificacoesPlm: `${API_VERSION}/product/classificacoes-plm`,
    biotipos: `${API_VERSION}/product/biotipos`,
    dnas: `${API_VERSION}/product/dnas`,
    plm: {
      faseamento: `${API_VERSION}/product/plm/faseamento`,
      faseamentoItens: `${API_VERSION}/product/plm/faseamento/itens`,
      faseamentoComposicao: `${API_VERSION}/product/plm/faseamento/composicao`,
      faseamentoCiclosMaturidade: `${API_VERSION}/product/plm/faseamento/ciclos-maturidade`,
      gates: `${API_VERSION}/product/plm/gates`,
      gatesDecisoes: `${API_VERSION}/product/plm/gates/decisoes`,
      itens: `${API_VERSION}/product/plm/itens`,
      checkupsRetroativos: `${API_VERSION}/product/plm/checkups/retroativos`
    }
  },
  execution: {
    notasFiscais: `${API_VERSION}/execution/notas-fiscais`,
    pedidos: 'pedido',
    pedidosPrevisaoEntrega: 'pedidos-previsao-entrega',
    titulosReceber: 'tituloreceber'
  }
};
